<template>
  <article class="advice-card">
    <a
      :href="data?.link"
      target="_blank"
      rel="noreferrer noopener"
    >
      <VImg
        :src="url"
        :alt="data?.title?.rendered"
        :aspect-ratio="16/9"
        cover
        loading="lazy"
      />
      <div class="advice-card__content">
        <div
          class="advice-card__content__tag"
          v-html="tag"
        />
        <h3
          class="advice-card__content__title"
          v-html="data?.title?.rendered"
        />
        <div
          class="advice-card__content__text"
          v-html="data?.excerpt?.rendered"
        />
      </div>
    </a>
  </article>
</template>

<script lang="ts" setup>
const props = defineProps<{
  data?: Record<string, any>
}>()

const tag = computed(() => {
  return props.data?.categories?.map((category: any) => category ? category.name : '').filter(Boolean).join(', ')
})
const url = computed(() => {
  return encodeURI(props.data?._embedded?.['wp:featuredmedia']?.[0]?.source_url)
})
</script>

<style lang="scss" scoped>
.advice-card {
  height: 100%;
  overflow: hidden;
  border-radius: 10px;
  background: $white;

  a {
    text-decoration: none;
  }

  &__img-container {
    position: relative;
    width: 100%;
    padding-top: 53.51%;

    img {
      position: absolute;
      inset: 0;
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }

  &__content {
    padding: 2em 1.5em;

    &__tag {
      font-size: 12px;
      color: #1f1f1f;
      margin-bottom: 14px;
      font-weight: normal;
    }

    &__title {
      font-size: 17px;
      font-weight: bold;
      color: #1f1f1f;
      margin-bottom: 14px;
    }

    &__text {
      font-size: 14px;
      color: rgba($night-blue, 60%);
      font-weight: normal;
    }
  }
}
</style>
